import "./svgStyle.scss"

import { useBlackFriday } from "../../context/blackFridayContext"
import { usePurchase } from "../../context/purchaseContext"
import {
  FeatureAlert,
  useUltimateAlerts,
} from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"
import svg from "../../utils/svg"
import { isPromo } from "../../utils/utils"
import styles from "./FeatureList.module.scss"
import { useAppState } from "../../context/appStateContext"
import { useExpiration } from "../../context/expirationContext"

export interface Feature {
  title: string
  inconSvg: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  badge?: string
  alert?: FeatureAlert
}

interface Props {
  lightContent?: boolean
  useModernExpirationStyle?: boolean
}

const FeatureList = (props: Props) => {
  const strings = useStrings()
  let ultimateSelected = usePurchase().state.ultimateSelected
  ultimateSelected = useBlackFriday().state.isUltimate || ultimateSelected
  ultimateSelected = useExpiration().state.isUltimate || ultimateSelected
  ultimateSelected =
    useAppState().state.productData?.activeSubscription?.productId.includes(
      "ultimate"
    ) || ultimateSelected

  //TODO: Extract this if needed

  let features: Feature[] = [
    {
      title: "Cloud Vault",
      inconSvg: svg.featureIcons.CloudVault,
      badge: strings.new,
    },
  ]

  if (ultimateSelected) {
    features[0].title = "Cloud Vault - 1,000 GB"

    features.push(
      {
        title: strings.features.organizationPlus,
        inconSvg: svg.featureIcons.OrganizationPlus,
        alert: "organization+",
      },
      {
        title: strings.features.securityPlus,
        inconSvg: svg.featureIcons.SecurityPlus,
        alert: "security+",
      },
      {
        title: strings.features.duplicateDetection,
        inconSvg: svg.featureIcons.DuplicateDetection,
      }
    )
  }

  features.push(
    {
      title: strings.trashRecovery,
      inconSvg: svg.featureIcons.Trash,
      badge: strings.new,
    },
    {
      title: strings.adFree,
      inconSvg: svg.featureIcons.Adfree,
    },
    {
      title: strings.breakIn,
      inconSvg: svg.featureIcons.Breakin,
    },
    {
      title: strings.wireless,
      inconSvg: svg.featureIcons.Wifi,
    },
    {
      title: strings.decoy,
      inconSvg: svg.featureIcons.Decoy,
    },
    {
      title: strings.pattern,
      inconSvg: svg.featureIcons.PatternLock,
    },
    {
      title: strings.appDisguise,
      inconSvg: svg.featureIcons.Disguise,
      badge: strings.comingSoon,
    }
  )

  return (
    <div
      className={`${styles.container} ${
        props.lightContent ? styles.lightContent : ""
      }`}
    >
      {features.map((feature, index) =>
        props.useModernExpirationStyle ? (
          <FeatureListItemModernExpiration feature={feature} key={index} />
        ) : (
          <FeatureListItem feature={feature} key={index} />
        )
      )}
    </div>
  )
}

interface FeatureListItemProps {
  feature: Feature
}

const FeatureListItem = (props: FeatureListItemProps) => {
  const { title, badge, alert } = props.feature
  const { actions } = useUltimateAlerts()

  const badgeStyle = isPromo() ? styles.newIconPromo : styles.newIcon

  return (
    <div className={styles.item}>
      <div className={styles.imageContainer}>
        <props.feature.inconSvg className={styles.image} />
      </div>
      <span className={styles.text}>{title}</span>
      {badge != null && <div className={badgeStyle}>{badge}</div>}
      {alert != null && (
        <button className={styles.infoContainer}>
          <svg.Info
            className={styles.info}
            onClick={() => {
              actions.setShowFeatureAlert(alert)
            }}
          />
        </button>
      )}
    </div>
  )
}

const FeatureListItemModernExpiration = (props: FeatureListItemProps) => {
  const { title, badge } = props.feature

  const badgeStyle = styles.newIconExpiration

  return (
    <div className={styles.itemExpiration}>
      <div className={styles.imageContainerExpiration}>
        <props.feature.inconSvg className={styles.imageExpiration} />
      </div>
      <span className={styles.textExpiration}>{title}</span>
      {badge != null && (
        <div className={badgeStyle}>
          <label>{badge.toUpperCase()}</label>
        </div>
      )}
    </div>
  )
}

export default FeatureList
